import React from 'react';
import PropTypes from 'prop-types';

import { listingDict } from '@redux/constants/GeneralConstants';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ListingTypeIcons = ({ type }) => (
  <OverlayTrigger
    placement="top"
    overlay={<Tooltip id={`tooltip-${type}-button`} style={{ margin: 0 }}>{listingDict[type.toString().toLowerCase()]}</Tooltip>}
  >
    {(() => {
      switch (type) {
        case 'RES':
          return <i className="fas fa-home-lg text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        case 'MULT':
          return <i className="fas fa-building text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        case 'RNT':
          return <i className="fas fa-store-alt text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        case 'COM':
          return <i className="fas fa-city text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        case 'FARM':
          return <i className="fas fa-farm text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        case 'MOB':
          return <i className="fas fa-caravan text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        case 'LAND':
          return <i className="fas fa-mountains text-muted" aria-label={listingDict[type.toString().toLowerCase()]} />;
        default:
          return '';
      }
    })()}
  </OverlayTrigger>
);

ListingTypeIcons.propTypes = {
  type: PropTypes.string.isRequired,
};

export default ListingTypeIcons;
